module.exports = __webpack_public_path__ + "static/media/CCR_Climate_Logo.ecf42e13.png";